import { render, staticRenderFns } from "./ThirdPartySabaDetailDialog.vue?vue&type=template&id=01887f35"
import script from "./ThirdPartySabaDetailDialog.vue?vue&type=script&lang=js"
export * from "./ThirdPartySabaDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports